// extracted by mini-css-extract-plugin
export var backdropBlur = "_ec-0";
export var contentCard = "_ec-5";
export var frame = "_ec-2";
export var image = "_ec-4";
export var imagePane = "_ec-3";
export var modal = "_ec-1";